/* eslint-disable camelcase */
// @flow
import styled, { css } from "styled-components";
import { media } from "@nested/ui";
import { blogWrapperStyles } from "../../../components/Blog/Breadcrumbs";

type Props = {
  header_col1: string,
  header_col2: string,
  header_col3?: ?string,
  repeat: {
    col1: string,
    col2: string,
    col3?: ?string,
  }[],
};

const TableWrapper = styled.div`
  margin: 15px 10px;
  ${media.tablet`
    margin: 15px auto;
  `};
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid ${({ theme }) => theme.palette.hague};
  max-width: 700px;
`;

const tableStyle = css`
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  table-layout: fixed;

  thead {
    background-color: ${({ theme }) => theme.palette.hague};
    th {
      padding: 15px 20px;
      color: white;
      font-weight: 500;
    }
  }

  tbody tr td {
    padding: 15px 20px;
    color: ${({ theme }) => theme.palette.hague};
    font-weight: 400;
  }
`;

export const MaxThreeColTable = ({
  repeat,
  header_col1,
  header_col2,
  header_col3,
}: Props) => {
  return (
    <div css={blogWrapperStyles}>
      <TableWrapper>
        <table css={tableStyle}>
          <thead>
            <tr>
              <th>{header_col1}</th>
              <th>{header_col2}</th>
              {header_col3 && <th>{header_col3}</th>}
            </tr>
          </thead>
          <tbody>
            {repeat.map(({ col1, col2, col3 }, key) => (
              <tr key={key}>
                <td>{col1}</td>
                <td>{col2}</td>
                {col3 && <td>{col3}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </TableWrapper>
    </div>
  );
};
